import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { bonusGameApi } from 'src/api/bonus-game';
import { CheckNextRewardsResponseObject } from 'src/api/Api';

const TimerWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0;
  gap: 4px;
  justify-content: center;
`;

const TimerText = styled.div`
  font-size: 12px;
  color: #7e8a93;
`;

const CountdownText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
`;

interface NextRewardTimerProps {
  endNumber: number;
}

export const NextRewardTimer = ({ endNumber }: NextRewardTimerProps) => {
  const [rewardData, setRewardData] =
    useState<null | CheckNextRewardsResponseObject>(null);
  const [targetDate, setTargetDate] = useState(0);
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const fetchRewardData = async () => {
      try {
        const nextReward = await bonusGameApi.checkNextReward();
        setRewardData(nextReward);
      } catch (error) {
        console.error('Failed to fetch reward data:', error);
      }
    };
    fetchRewardData();
  }, [endNumber]);

  useEffect(() => {
    if (!rewardData) return;
    const unlockTime = new Date(
      rewardData.unlockNextRewardTime as unknown as string,
    ).getTime();
    setTargetDate(unlockTime);
  }, [rewardData]);

  useEffect(() => {
    if (!targetDate) return;

    const timer = setInterval(() => {
      const now = Date.now();
      const difference = Math.max(targetDate - now, 0);

      setTimeLeft({
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / (1000 * 60)) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate, endNumber]);

  const formatTime = (value: number): string => {
    return value < 10 ? `0${value}` : `${value}`;
  };

  return (
    <TimerWrapper>
      <TimerText>Next reward in</TimerText>
      <CountdownText>
        {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
        {formatTime(timeLeft.seconds)}
      </CountdownText>
    </TimerWrapper>
  );
};
